import { render, staticRenderFns } from "./likeBtn.vue?vue&type=template&id=bff8b4d0&scoped=true"
import script from "./likeBtn.vue?vue&type=script&lang=js"
export * from "./likeBtn.vue?vue&type=script&lang=js"
import style0 from "./likeBtn.vue?vue&type=style&index=0&id=bff8b4d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff8b4d0",
  null
  
)

export default component.exports